import { render, staticRenderFns } from "./PasswordForgottenForm.vue?vue&type=template&id=91238a06&scoped=true&"
import script from "./PasswordForgottenForm.vue?vue&type=script&lang=js&"
export * from "./PasswordForgottenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91238a06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91238a06')) {
      api.createRecord('91238a06', component.options)
    } else {
      api.reload('91238a06', component.options)
    }
    module.hot.accept("./PasswordForgottenForm.vue?vue&type=template&id=91238a06&scoped=true&", function () {
      api.rerender('91238a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/PasswordForgottenForm.vue"
export default component.exports